import type { Asset } from "@/data/types";
import { Card, Fld, PaneHeader } from "./parts";

export default function ViewerTab({ asset }: { asset: Asset }) {
  const current = asset.versions.at(-1)!;

  return (
    <section className="pane">
      <PaneHeader
        asset={asset}
        h2="Visualizzatore 3D"
        sub={
          <>
            {asset.ref} · {current.id} · {asset.acquisitionDetail.toUpperCase()}{" "}
            · {asset.triangles.toUpperCase()} TRIANGOLI
          </>
        }
      />

      <Card
        title="◱ Parametri di acquisizione"
        note={`sessione ${asset.date} · ${asset.acquisition === "Fotogrammetria" ? "1 passata" : "3 passate"}`}
      >
        <div className="fgrid">
          <Fld label="Metodo" value={asset.acquisitionDetail} />
          <Fld label="Passo di scansione" value="0.04 mm" />
          <Fld
            label="Triangoli"
            value={Math.round(asset.trianglesM * 1_000_000).toLocaleString(
              "it-IT",
            )}
          />
          <Fld label="Texture" value={asset.texture} />
          <Fld label="Formati" value={asset.formats} />
          <Fld label="Dimensione" value={asset.size} />
        </div>

        <div className="stub">
          <span className="gl">◍</span>
          <div className="tt">Viewer interattivo non ancora collegato</div>
          <div className="ds">
            La mesh è disponibile in USDZ e OBJ. In questo prototipo il nucleo
            di Esplora è un'immagine statica: la rotazione libera della
            scansione è il prossimo sviluppo previsto.
          </div>
        </div>
      </Card>
    </section>
  );
}
